module.exports = __webpack_public_path__ + "static/media/download-icon.3bac5779.svg";